export enum Route {
  Home = '/',
  Opportunities = '/opportunities',
  Opportunity = '/opportunities/:opportunityId',

  Selling = '/selling/',
  SellingOpportunity = '/selling/opportunities/:opportunityId',
  SellingOffer = '/selling/offers/:offerId',

  Buying = '/buying/',
  BuyingOffer = '/buying/offers/:offerId',

  // Legacy:
  MyOpportunities = '/my-opportunities/',
  MyOpportunity = '/my-opportunities/:opportunityId',

  Projects = '/projects',
  Project = '/projects/:projectId',
  Offers = '/offers',
  Offer = '/offers/:offerId',
  Services = '/services',
  Service = '/services/:serviceId',
  Prices = '/prices',
  Transactions = '/transactions',

  ProfileSettings = '/settings/profile',
  CompanySettings = '/settings/company',
  TeamSettings = '/settings/team',
  PlanSettings = '/settings/plans-and-billing',

  SignIn = '/auth/signin',
  SignUp = '/auth/signup',
  SignUpSuccess = '/auth/signup/success',
  VerifyEmailAddress = '/auth/verify',
  InvitationSignUp = '/auth/invitation/signup',
  RecoveryPassword = '/auth/password/recovery',
  RecoveryPasswordSuccess = '/auth/password/recovery/success',
  ResetPassword = '/auth/password/reset',

  TermsAndConditions = '/legal/terms-and-conditions',
  PrivacyPolicy = '/legal/privacy-policy',
  Forbidden = '/forbidden',
}
